import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { serverConn } from '../../API/apiRequest'
import { Button } from '../../components/Button/Button'
import { Logo } from '../../components/Logo/Logo'
import { NavText } from '../../components/NavElements'
import TextField from '../../components/TextField/TextField'
import { login } from '../../State/Slice/userSlice'
import classes from './Login.module.css'
import ReactGA from 'react-ga'
interface Props {

}

export const Login: React.FC<Props> = () => {
  const { pathname } = useLocation()

  const [loading, setLoading] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [err, setErr] = useState<string>('')
  const dispatch = useDispatch()

  useEffect(()=>{
      window.scrollTo(0, 0)
      ReactGA.pageview(window.location.pathname)


  },[pathname])


  const doLogin = async()=>{
    setLoading(true)
    if(email && password){
      try{
      let result = await serverConn.post('/login', {email, password})
      await localStorage.setItem('user', JSON.stringify(result.data))
      if(result.data.type === 'EE'){
        dispatch(login({
          type: result.data.type,
          name: result.data.name,
          picture: result.data.picture,
          refresh: result.data.refreshToken,
          logId: result.data.log
        }))
      }
      else{
        dispatch(login({
          type: result.data.type,
          name: result.data.name,
          companyName: result.data.companyName,
          picture: result.data.picture,
          refresh: result.data.refreshToken,
          logId: result.data.log
        }))
      }
      }catch(e: any){
        if(e.response.data)
          setErr(e.response.data.errors[0])
      }
    }

    setLoading(false)
  }


    return (
    <div className={classes.container}>
        <div className={classes.darker}>
         <div className={classes.form}> 
          <NavText to='/'> <Logo/> </NavText>
          <div>
            <TextField 
              placeholder='اسم المستخدم' 
              iconName='FiUser' 
              style={{backgroundColor: '#1D252D', opacity: 0.7}} 
              width={200}
               
              value={email}
              handleChange={({target})=>setEmail(target.value)}
              />
            <div style={{width: 5, height: 10}}/>
            <TextField 
              type='password' 
              placeholder='كلمة المرور' 
              iconName='FiLock' 
              style={{backgroundColor: '#1D252D', opacity: 0.7}} 
              width={200}
               
              value={password}
              handleChange={({target})=>setPassword(target.value)}
              />
            </div>
            
            <Button 
              height={42} 
              width={160} 
              color='#1D252D' 
              loading={loading}
              onPress={()=>doLogin()}
              style={{opacity: 0.8}}>دخول</Button>
          </div>
          <div className={classes.errMsgDiv}>
              {err && <p className={classes.errMsg}>{err}</p>}
          </div>
          <LastDiv />
        </div>
    </div>
    )
}


const LastDiv: React.FC = ()=>{

  return(
    <div className={classes.lastDiv}>
      <NavText to='/register' style={{fontSize: 15, fontWeight: 200}}>
        التسجيل
      </NavText>
        <p style={{color: 'white', fontWeight: 200, paddingLeft: 15, paddingRight: 0}}>
          |
        </p>
      <NavText to='/forget' style={{fontSize: 15, fontWeight: 200}}>
        نيست كلمة المرور
      </NavText>
    </div>
  )
}